
export default {
  name: 'AppModal',
  props: {
    location: {
      type: String,
      default: 'center',
      validator: v => ['center', 'bottom'].includes(v)
    }
  }
};
